<template>
    <div class="footer">
        <img src="../assets/img/sbp.svg" alt="">
        <p><b>Pay Every Day.</b><br> Все права защищены</p>
    </div>
</template>

<script>
</script>